module.exports = __webpack_public_path__ + "static/media/GURAKH_H.193ceedc.ttf";